"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _default = {
  name: 'LotDetailProvisionsRisques',
  props: ['idLot'],
  data: function data() {
    return {
      CONST: CONST,
      refresh: 0,
      refreshheader: 0,
      lotsDetail: [],
      calculs: [],
      totaux: [],
      libsNature: [],
      modeEdit: false
    };
  },
  computed: {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    },
    maxOrdre: function maxOrdre() {
      var max = 0;

      if (this.lotsDetail.length > 0) {
        max = Math.max.apply(Math, this.$store.getters.affaire.lotsDetail.map(function (x) {
          return x.ordre;
        }));
      }

      return max + 1;
    },
    nbCol: function nbCol() {
      return this.affaire.nbColProvisionRisque;
    }
  },
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    _eventBus.EventBus.$on('REFRESH', function () {
      var typeLigne = [CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE, CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION_RISQUE, CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL, CONST.LOT_DETAIL.TYPE_LIGNE.TRANSFERT, CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE];
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });
      _this2.refreshheader++; // pour forcer le rafraichissement des entetes de colonnes
    });

    _eventBus.EventBus.$on('PROVISIONRISQUE_NEW', function () {
      _this2.modeEdit = true;
    });

    _eventBus.EventBus.$on('PROVISIONRISQUE_CANCEL', function () {
      _this2.modeEdit = false;

      _this2.onCancelProvisionRisque();
    });

    _eventBus.EventBus.$on('PROVISIONRISQUE_SAVE', function (libNature) {
      _this2.modeEdit = false;

      _this2.onSaveProvisionRisque(libNature); // enregistre les montants et fige la derniere colonne des provisions

    });

    this.refresh++;
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('REFRESH');

    _eventBus.EventBus.$off('PROVISIONRISQUE_NEW');

    _eventBus.EventBus.$off('PROVISIONRISQUE_CANCEL');

    _eventBus.EventBus.$off('PROVISIONRISQUE_SAVE');
  },
  methods: {
    libNature: function libNature(numCol) {
      var libsNature = this.$store.getters.affaire.provisionsRisques.filter(function (x) {
        return x.num_colonne === numCol;
      }).map(function (x) {
        return x.lib_nature;
      });

      var uniqLibs = _toConsumableArray(new Set(libsNature));

      return uniqLibs && uniqLibs.length > 0 ? uniqLibs[0] : '';
    },
    canAddProvisionRisque: function canAddProvisionRisque(scope) {
      // si on est en gestion mensuelle, on s'assure qu'on ne peut passer une provision que sur une ligne validée
      var testOnlyGestMens = true;

      if (this.affaire.affaire.etape === CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value) {
        testOnlyGestMens = scope.row.validation === 1;
      }

      return scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION_RISQUE || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.PROVISION || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.TRANSFERT || testOnlyGestMens && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE || testOnlyGestMens && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE;
    },
    gestMens: function gestMens(numCol) {
      if (this.affaire.calculs.affaire) {
        return this.affaire.calculs.affaire.colonneProvisionRisque[numCol].periode_gestmens;
      }
    },
    dateCol: function dateCol(numCol) {
      if (this.affaire.calculs.affaire) {
        // return this.affaire.calculs.affaire.dateColonneProvisionRisque[numCol]
        var d = this.affaire.calculs.affaire.colonneProvisionRisque[numCol].date_creation;
        return d;
      }
    },
    mtTotalLotColonneProvisionRisque: function mtTotalLotColonneProvisionRisque(index, column) {
      return this.totaux[index] && this.totaux[index].mtTotalLotColonneProvisionRisque[column] ? this.totaux[index].mtTotalLotColonneProvisionRisque[column] : '';
    },
    mtTotalLotLigneProvisionRisque: function mtTotalLotLigneProvisionRisque(index) {
      return this.totaux[index] ? this.totaux[index].mtTotalLotLigneProvisionRisque : '';
    },
    handleInput: function handleInput(scope, action) {
      var data = {
        id_lot_detail: scope.row.id,
        num_colonne: this.nbCol + 1,
        lib_nature: '',
        mt_provisionrisque: scope.row.mt_provisionrisque,
        date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
        periode_gestmens: this.affaire.YYYYMM ? this.affaire.YYYYMM : '',
        etape_origine: this.affaire.affaire.etape
      };
      this.$store.dispatch('affaire/setProvisionRisque', data).then(function () {
        if (action === 'refresh_calcul') {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');
        }
      });
    },
    onCancelProvisionRisque: function onCancelProvisionRisque() {
      // pour vider le champ de saisie et ne pas avoir l'ancienne valeur quand on fera "Nouvelle provision"
      this.lotsDetail.forEach(function (row) {
        row.mt_provisionrisque = '';
      });
      this.$store.commit('affaire/DEL_ALLPROVISIONRISQUE_BY_NUMCOL', this.nbCol + 1);

      _eventBus.EventBus.$emit('REFRESH_CALCULS');
    },
    onSaveProvisionRisque: function () {
      var _onSaveProvisionRisque = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(libNature) {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.lotsDetail.forEach( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(row) {
                    var mt, data;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            mt = row.mt_provisionrisque || '';

                            if (!(mt !== '')) {
                              _context.next = 6;
                              break;
                            }

                            data = {
                              id_lot_detail: row.id,
                              num_colonne: _this3.nbCol + 1,
                              lib_nature: libNature || '',
                              mt_provisionrisque: row.mt_provisionrisque,
                              date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
                              periode_gestmens: _this3.affaire.YYYYMM ? _this3.affaire.YYYYMM : '',
                              etape_origine: _this3.affaire.affaire.etape
                            };
                            _context.next = 5;
                            return _this3.$store.dispatch('affaire/insertProvisionRisque', data);

                          case 5:
                            row.mt_provisionrisque = ''; // pour vider le champ de saisie du montant

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
                this.$root.modeEdit = false;

                _eventBus.EventBus.$emit('REFRESH_CALCULS');

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onSaveProvisionRisque(_x) {
        return _onSaveProvisionRisque.apply(this, arguments);
      }

      return onSaveProvisionRisque;
    }()
  }
};
exports.default = _default;